import React from "react"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import moment from "moment"
import IconDatePicker from "./IconDatePicker"
import * as timeHelper from "../../helpers/timeHelper"
import { IDate } from "../../models"
interface IProps {
    // these datetime should be local time utc format
    startDate: IDate
    endDate: IDate
    sameDatesAllowed?: boolean
    timeLabel?: boolean
    spaceBetween?: number
    datePickerWidth?: number
    readonly?: boolean
    handleChange(startDate: IDate, endDate: IDate, isValid: boolean): void
    errorStartDate?: string
    errorEndDate?: string
}
interface IState {
    startDate: IDate
    errorStartDate: string
    endDate: IDate
    errorEndDate: string
}

export default class DateRangeSelect extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            startDate: props.startDate,
            errorStartDate: "",
            endDate: props.endDate,
            errorEndDate: "",
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps: IProps) {
        !(moment(this.props.startDate).isSame(nextProps.startDate) && moment(this.props.endDate).isSame(nextProps.endDate)) &&
            this.setState({
                startDate: nextProps.startDate,
                endDate: nextProps.endDate
            })
    }

    handleChange() {
        const isInValid = this.props.sameDatesAllowed ?
            moment(timeHelper.keepConvertUTCToLocal(this.state.startDate)).isAfter(timeHelper.keepConvertUTCToLocal(this.state.endDate), "day") :
            moment(timeHelper.keepConvertUTCToLocal(this.state.startDate)).isSameOrAfter(timeHelper.keepConvertUTCToLocal(this.state.endDate), "day")
        this.setState({ errorEndDate: isInValid && strings.Invalid_date_range })
        this.props.handleChange(this.state.startDate, this.state.endDate, !isInValid)
    }

    render() {
        return (
            <div style={{ display: "flex" }}>
                <IconDatePicker
                    label={this.props.timeLabel ? strings.Start_Time : strings.Start_Date}
                    errorText={this.state.errorStartDate || this.props.errorStartDate}
                    width={this.props.datePickerWidth}
                    date={this.state.startDate !== null ? moment(timeHelper.keepConvertUTCToLocal(this.state.startDate)).toDate() : null}
                    handleSelectDate={date => this.setState({ startDate: moment(date).startOf("day").utc(true).format() }, () =>
                        this.handleChange()
                    )}
                    readonly={this.props.readonly}
                />
                <IconDatePicker
                    style={{ marginLeft: this.props.spaceBetween ? this.props.spaceBetween : 20 }}
                    label={this.props.timeLabel ? strings.End_Time : strings.End_Date}
                    errorText={this.state.errorEndDate || this.props.errorEndDate}
                    width={this.props.datePickerWidth}
                    date={this.state.endDate !== null ? moment(timeHelper.keepConvertUTCToLocal(this.state.endDate)).toDate() : null}
                    handleSelectDate={date => this.setState({ endDate: moment(date).endOf("day").utc(true).format() }, () =>
                        this.handleChange()
                    )}
                    readonly={this.props.readonly}
                />
            </div>
        )
    }
}